import { useAppDispatch, useAppSelector } from 'js/store/hooks';

import {
  clearReplaceImage as cancelReplaceImageAction,
  startReplaceImage as startReplaceImageAction
} from '../../actionCreators/imagesActions';

export default function useReplaceImage() {
  const dispatch = useAppDispatch();
  const { replacingImageElementId } = useAppSelector(state => state.images);

  const cancelReplaceImage = () => {
    dispatch(cancelReplaceImageAction());
  };

  const startReplaceImage = (imageElementId: string) => {
    dispatch(startReplaceImageAction(imageElementId));
  };

  return {
    replacingImageElementId,
    isInReplaceImageMode: !!replacingImageElementId,
    cancelReplaceImage,
    startReplaceImage
  };
}
